<template>
  <div class="page_all">
    <!-- <loading
      :active.sync="isLoading"
      :can-cancel="true"
      :on-cancel="onCancel"
      :is-full-page="fullPage"></loading>
      <div class="return_link"> -->
    <loading
      :active.sync="isLoading"
      :on-cancel="onCancel"
      :is-full-page="fullPage"></loading>
      <div class="return_link">
      <router-link to="/pushNotificationTrainingList">＞ プッシュ通知(訓練用)</router-link>
    </div>
    <div class="page_header">
      <div class="header_title">
        <div v-if="status==1" class="title">プッシュ通知(訓練用)の詳細</div>
        <div v-else-if="changeFlg" class="title">プッシュ通知(訓練用)の編集</div>
        <div v-else class="title">プッシュ通知(訓練用)の追加</div>
      </div>
      <div v-if="status==0 || status==3" class="btn_header">
        <button :disabled="$v.$invalid || this.updating" v-if="templateFlg == 1" class="btn_general" v-on:click="pushSave(1)">テンプレートを更新</button>
        <button :disabled="$v.$invalid || this.updating" v-else class="btn_general" v-on:click="pushAdd(1)">テンプレートとして保存</button>
        <button :disabled="$v.$invalid || this.updating" v-if="changeFlg && templateFlg != 1" class="btn_general" v-on:click="pushSave(0)">下書きで保存</button>
        <button :disabled="$v.$invalid || this.updating" v-else class="btn_general" v-on:click="pushAdd(0)">下書きで保存</button>
        <!-- <button :disabled="$v.$invalid" class="btn_general" v-on:click="pushRelease()">公開</button> -->
        <button :disabled="$v.$invalid || this.updating" class="btn_general" v-on:click="open_modal_release">送信</button>
        <modal name="modal_release" :draggable="true" :resizable="true" :height="300" :width="630">
          <div class="modal_header">
            <p class="modal_title">送信して、よろしいですか？</p>
            <div class="modal_string_div">
              <span class="modal_string">※言語について</span>
              <ul>
                <li class="modal_li">端末の言語設定に応じて通知が送信されます</li>
                <li v-if="unfilledPushLanguageStr != ''" class="modal_li">{{ unfilledPushLanguageStr }}の入力がされていないため、{{ checkPrimary() }}の内容を送信します</li>
              </ul>
            </div>
          </div>
          <div class="modal-body">
            <div class="modal_btn_div">
              <button :disabled="$v.$invalid" v-if="templateFlg == 1" class="btn btn-outline-primary modal_btn" v-on:click="pushRelease(1)">送信</button>
              <button :disabled="$v.$invalid" v-else class="btn btn-outline-primary modal_btn" v-on:click="pushRelease(0)">送信</button>
              <button class="btn btn-outline-primary modal_btn" @click="close_modal_release">閉じる</button>
              <!-- <button class="btn btn-outline-primary modal_btn" @click="deleteTraining(push.id)">削除</button>
              <button class="btn btn-outline-primary" v-on:click="hide(push.id)">キャンセル</button> -->
            </div>
          </div>  
        </modal>
      </div>
      <div v-else-if="status == 1">
        <button :disabled="$v.$invalid || this.updating" class="btn_general" v-on:click="pushAdd(1)">テンプレートとして保存</button>
      </div>
    </div>
    <div class="area_radios_div">
      <div class="area_radio_div" v-for="language in languages" v-bind:key="language.language_id">
        <input class="area_radio_input" :id="'ja_radio_' + language.language_id" type="radio" :value="language.language_id" v-model=languageRadio @change="changeLanguage">
        <label class="area_radio_label" :for='"ja_radio_" + language.language_id'>
            {{ language.language_name}}
        </label>
      </div>
    </div>
    <div v-if="message != ''" class="message">
      <div class="error">{{ message }}</div>
    </div>
    <div class="page_main">
      <!-- jaのみ -->
      <table v-if="languageRadio == 1" class="tbl_main">
        <thead>
          <tr>
            <th class="th_message" colspan="4">管理</th>
          </tr>
        </thead>
        <tbody>
          <tr class="tr_top">
            <td class="td_head_top">管理名、管理メモ</td>
            <td class="td_content_top" colspan="3">
              <input v-model.trim="$v.notificationName.$model" type="text" class="text_title" v-bind:disabled="disabledFlg"/>
              <div class="message">
                <div v-if="$v.notificationName.$dirty">
                  <div class="error" v-if="!$v.notificationName.required">管理名、管理メモは必須入力です。</div>
                  <div class="error" v-if="!$v.notificationName.maxLength">管理名、管理メモは{{ $v.notificationName.$params.maxLength.max }}文字以内で入力してください。</div>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <br v-if="languageRadio == 1" />
      <br v-if="languageRadio == 1" />
      <table class="tbl_main">
        <thead>
          <tr>
            <th class="th_message" colspan="4">メッセージ</th>
          </tr>
        </thead>
        <!-- ja -->
        <tbody v-if="languageRadio == 1">
          <tr class="tr_top">
            <td class="td_head_top">通知タイトル</td>
            <td class="td_content_top" colspan="3">
              <input v-model.trim="$v.pushTitle.$model" type="text" class="text_title" v-bind:disabled="disabledFlg" />
              <div class="message">
                <div v-if="$v.pushTitle.$dirty">
                  <div class="error" v-if="!$v.pushTitle.required">タイトルは必須入力です。</div>
                  <div class="error" v-if="!$v.pushTitle.maxLength">通知タイトルは{{ $v.pushTitle.$params.maxLength.max }}文字以内で入力してください。</div>
                </div>
              </div>
            </td>
          </tr>
          <tr class="tr_top">
            <td class="td_head_middle">本文</td>
            <td class="td_content_middle" colspan="3">
              <textarea v-model.trim="$v.pushMessage.$model" type="text" class="text_body" v-bind:disabled="disabledFlg" rows="5"/>
              <div class="message">
                <div v-if="$v.pushMessage.$dirty">
                  <div class="error" v-if="!$v.pushMessage.required">本文は必須入力です。</div>
                  <div class="error" v-if="!$v.pushMessage.maxLength">本文は{{ $v.pushMessage.$params.maxLength.max }}文字以内で入力してください。</div>
                </div>
              </div>
            </td>
          </tr>
          <tr class="tr_top">
            <td class="td_head_bottom">リンクタイトル</td>
            <td class="td_content_link_title">
              <input v-model.trim="$v.linkTitle.$model" type="text" class="text_link_title" v-bind:disabled="disabledFlg"/>
              <div class="message">
                <div v-if="$v.linkTitle.$dirty">
                  <!-- <div class="error" v-if="!$v.linkTitle.required">リンクタイトルは必須入力です。</div> -->
                  <div class="error" v-if="!$v.linkTitle.maxLength">リンクタイトルは{{ $v.linkTitle.$params.maxLength.max }}文字以内で入力してください。</div>
                </div>
              </div>
            </td>
            <td class="td_head_url">URL</td>
            <td class="td_content_link_url">
              <input v-model.trim="$v.linkUrl.$model" type="text" class="text_link_url" v-bind:disabled="disabledFlg"/>
              <div class="message">
                <div v-if="$v.linkUrl.$dirty">
                  <!-- <div class="error" v-if="!$v.linkUrl.required">URLは必須入力です。</div> -->
                  <div class="error" v-if="!$v.linkUrl.url">URLを入力してください。</div>
                  <div class="error" v-if="!$v.linkUrl.maxLength">URLは{{ $v.linkUrl.$params.maxLength.max }}文字以内で入力してください。</div>
                </div>
              </div>
            </td>
          </tr>
          <tr v-if="this.$store.getters.getStateIsSoundAuth" class="tr_top">
            <td class="td_head_bottom">防災通知音を使用する</td>
            <td class="td_content_bottom" colspan="3">
              <input type="checkbox" v-model="soundFlg" class="check_sound" v-bind:disabled="disabledFlg">
            </td>
          </tr>
        </tbody>
        <!-- en -->
        <tbody v-if="languageRadio == 2">
          <tr class="tr_top">
            <td class="td_head_top">通知タイトル(英語)</td>
            <td class="td_content_top" colspan="3">
              <input v-model.trim="$v.pushTitle_ei.$model" type="text" class="text_title" v-bind:disabled="disabledFlg" />
              <div class="message">
                <div v-if="$v.pushTitle_ei.$dirty">
                  <div class="error" v-if="!$v.pushTitle_ei.maxLength">通知タイトル(英語)は{{ $v.pushTitle_ei.$params.maxLength.max }}文字以内で入力してください。</div>
                </div>
              </div>
            </td>
          </tr>
          <tr class="tr_top">
            <td class="td_head_middle">本文(英語)</td>
            <td class="td_content_middle" colspan="3">
              <textarea v-model.trim="$v.pushMessage_ei.$model" type="text" class="text_body" v-bind:disabled="disabledFlg" rows="5"/>
              <div class="message">
                <div v-if="$v.pushMessage_ei.$dirty">
                  <div class="error" v-if="!$v.pushMessage_ei.maxLength">本文(英語)は{{ $v.pushMessage_ei.$params.maxLength.max }}文字以内で入力してください。</div>
                </div>
              </div>
            </td>
          </tr>
          <tr class="tr_top">
            <td class="td_head_bottom">リンクタイトル(英語)</td>
            <td class="td_content_link_title">
              <input v-model.trim="$v.linkTitle_ei.$model" type="text" class="text_link_title" v-bind:disabled="disabledFlg"/>
              <div class="message">
                <div v-if="$v.linkTitle_ei.$dirty">
                  <!-- <div class="error" v-if="!$v.linkTitle.required">リンクタイトルは必須入力です。</div> -->
                  <div class="error" v-if="!$v.linkTitle_ei.maxLength">リンクタイトル(英語)は{{ $v.linkTitle_ei.$params.maxLength.max }}文字以内で入力してください。</div>
                </div>
              </div>
            </td>
            <td class="td_head_url">URL</td>
            <td class="td_content_link_url">
              <input v-model.trim="$v.linkUrl_ei.$model" type="text" class="text_link_url" v-bind:disabled="disabledFlg"/>
              <div class="message">
                <div v-if="$v.linkUrl_ei.$dirty">
                  <!-- <div class="error" v-if="!$v.linkUrl.required">URLは必須入力です。</div> -->
                  <div class="error" v-if="!$v.linkUrl_ei.url">URLを入力してください。</div>
                  <div class="error" v-if="!$v.linkUrl_ei.maxLength">URLは{{ $v.linkUrl_ei.$params.maxLength.max }}文字以内で入力してください。</div>
                </div>
              </div>
            </td>
          </tr>
          <tr v-if="this.$store.getters.getStateIsSoundAuth" class="tr_top">
            <td class="td_head_bottom">防災通知音を使用する</td>
            <td class="td_content_bottom" colspan="3">
              <input type="checkbox" v-model="soundFlg_ei" class="check_sound" v-bind:disabled="disabledFlg">
            </td>
          </tr>
        </tbody>
        <!-- 韓国語 -->
        <tbody v-if="languageRadio == 3">
          <tr class="tr_top">
            <td class="td_head_top">通知タイトル(韓国語)</td>
            <td class="td_content_top" colspan="3">
              <input v-model.trim="$v.pushTitle_kan.$model" type="text" class="text_title" v-bind:disabled="disabledFlg" />
              <div class="message">
                <div v-if="$v.pushTitle_kan.$dirty">
                  <div class="error" v-if="!$v.pushTitle_kan.maxLength">通知タイトル(韓国語)は{{ $v.pushTitle_kan.$params.maxLength.max }}文字以内で入力してください。</div>
                </div>
              </div>
            </td>
          </tr>
          <tr class="tr_top">
            <td class="td_head_middle">本文(韓国語)</td>
            <td class="td_content_middle" colspan="3">
              <textarea v-model.trim="$v.pushMessage_kan.$model" type="text" class="text_body" v-bind:disabled="disabledFlg" rows="5"/>
              <div class="message">
                <div v-if="$v.pushMessage_kan.$dirty">
                  <div class="error" v-if="!$v.pushMessage_kan.maxLength">本文(韓国語)は{{ $v.pushMessage_kan.$params.maxLength.max }}文字以内で入力してください。</div>
                </div>
              </div>
            </td>
          </tr>
          <tr class="tr_top">
            <td class="td_head_bottom">リンクタイトル(韓国語)</td>
            <td class="td_content_link_title">
              <input v-model.trim="$v.linkTitle_kan.$model" type="text" class="text_link_title" v-bind:disabled="disabledFlg"/>
              <div class="message">
                <div v-if="$v.linkTitle_kan.$dirty">
                  <!-- <div class="error" v-if="!$v.linkTitle.required">リンクタイトルは必須入力です。</div> -->
                  <div class="error" v-if="!$v.linkTitle_kan.maxLength">リンクタイトル(韓国語)は{{ $v.linkTitle_kan.$params.maxLength.max }}文字以内で入力してください。</div>
                </div>
              </div>
            </td>
            <td class="td_head_url">URL</td>
            <td class="td_content_link_url">
              <input v-model.trim="$v.linkUrl_kan.$model" type="text" class="text_link_url" v-bind:disabled="disabledFlg"/>
              <div class="message">
                <div v-if="$v.linkUrl_kan.$dirty">
                  <!-- <div class="error" v-if="!$v.linkUrl.required">URLは必須入力です。</div> -->
                  <div class="error" v-if="!$v.linkUrl_kan.url">URLを入力してください。</div>
                  <div class="error" v-if="!$v.linkUrl_kan.maxLength">URLは{{ $v.linkUrl_kan.$params.maxLength.max }}文字以内で入力してください。</div>
                </div>
              </div>
            </td>
          </tr>
          <tr v-if="this.$store.getters.getStateIsSoundAuth" class="tr_top">
            <td class="td_head_bottom">防災通知音を使用する</td>
            <td class="td_content_bottom" colspan="3">
              <input type="checkbox" v-model="soundFlg_kan" class="check_sound" v-bind:disabled="disabledFlg">
            </td>
          </tr>
        </tbody>
        <!-- 中国語:繁体字 -->
        <tbody v-if="languageRadio == 4">
          <tr class="tr_top">
            <td class="td_head_top">通知タイトル(繁体字)</td>
            <td class="td_content_top" colspan="3">
              <input v-model.trim="$v.pushTitle_chu_han.$model" type="text" class="text_title" v-bind:disabled="disabledFlg" />
              <div class="message">
                <div v-if="$v.pushTitle_chu_han.$dirty">
                  <div class="error" v-if="!$v.pushTitle_chu_han.maxLength">通知タイトル(繁体字)は{{ $v.pushTitle_chu_han.$params.maxLength.max }}文字以内で入力してください。</div>
                </div>
              </div>
            </td>
          </tr>
          <tr class="tr_top">
            <td class="td_head_middle">本文(繁体字)</td>
            <td class="td_content_middle" colspan="3">
              <textarea v-model.trim="$v.pushMessage_chu_han.$model" type="text" class="text_body" v-bind:disabled="disabledFlg" rows="5"/>
              <div class="message">
                <div v-if="$v.pushMessage_chu_han.$dirty">
                  <div class="error" v-if="!$v.pushMessage_chu_han.maxLength">本文(繁体字)は{{ $v.pushMessage_chu_han.$params.maxLength.max }}文字以内で入力してください。</div>
                </div>
              </div>
            </td>
          </tr>
          <tr class="tr_top">
            <td class="td_head_bottom">リンクタイトル(繁体字)</td>
            <td class="td_content_link_title">
              <input v-model.trim="$v.linkTitle_chu_han.$model" type="text" class="text_link_title" v-bind:disabled="disabledFlg"/>
              <div class="message">
                <div v-if="$v.linkTitle_chu_han.$dirty">
                  <!-- <div class="error" v-if="!$v.linkTitle.required">リンクタイトルは必須入力です。</div> -->
                  <div class="error" v-if="!$v.linkTitle_chu_han.maxLength">リンクタイトル(繁体字)は{{ $v.linkTitle_chu_han.$params.maxLength.max }}文字以内で入力してください。</div>
                </div>
              </div>
            </td>
            <td class="td_head_url">URL</td>
            <td class="td_content_link_url">
              <input v-model.trim="$v.linkUrl_chu_han.$model" type="text" class="text_link_url" v-bind:disabled="disabledFlg"/>
              <div class="message">
                <div v-if="$v.linkUrl_chu_han.$dirty">
                  <!-- <div class="error" v-if="!$v.linkUrl.required">URLは必須入力です。</div> -->
                  <div class="error" v-if="!$v.linkUrl_chu_han.url">URLを入力してください。</div>
                  <div class="error" v-if="!$v.linkUrl_chu_han.maxLength">URLは{{ $v.linkUrl_chu_han.$params.maxLength.max }}文字以内で入力してください。</div>
                </div>
              </div>
            </td>
          </tr>
          <tr v-if="this.$store.getters.getStateIsSoundAuth" class="tr_top">
            <td class="td_head_bottom">防災通知音を使用する</td>
            <td class="td_content_bottom" colspan="3">
              <input type="checkbox" v-model="soundFlg_chu_han" class="check_sound" v-bind:disabled="disabledFlg">
            </td>
          </tr>
        </tbody>
        <!-- 中国語:簡体字 -->
        <tbody v-if="languageRadio == 5">
          <tr class="tr_top">
            <td class="td_head_top">通知タイトル(簡体字)</td>
            <td class="td_content_top" colspan="3">
              <input v-model.trim="$v.pushTitle_chu_kan.$model" type="text" class="text_title" v-bind:disabled="disabledFlg" />
              <div class="message">
                <div v-if="$v.pushTitle_chu_kan.$dirty">
                  <div class="error" v-if="!$v.pushTitle_chu_kan.maxLength">通知タイトル(簡体字)は{{ $v.pushTitle_chu_kan.$params.maxLength.max }}文字以内で入力してください。</div>
                </div>
              </div>
            </td>
          </tr>
          <tr class="tr_top">
            <td class="td_head_middle">本文(簡体字)</td>
            <td class="td_content_middle" colspan="3">
              <textarea v-model.trim="$v.pushMessage_chu_kan.$model" type="text" class="text_body" v-bind:disabled="disabledFlg" rows="5"/>
              <div class="message">
                <div v-if="$v.pushMessage_chu_kan.$dirty">
                  <div class="error" v-if="!$v.pushMessage_chu_kan.maxLength">本文(簡体字)は{{ $v.pushMessage_chu_kan.$params.maxLength.max }}文字以内で入力してください。</div>
                </div>
              </div>
            </td>
          </tr>
          <tr class="tr_top">
            <td class="td_head_bottom">リンクタイトル(簡体字)</td>
            <td class="td_content_link_title">
              <input v-model.trim="$v.linkTitle_chu_kan.$model" type="text" class="text_link_title" v-bind:disabled="disabledFlg"/>
              <div class="message">
                <div v-if="$v.linkTitle_chu_kan.$dirty">
                  <!-- <div class="error" v-if="!$v.linkTitle.required">リンクタイトルは必須入力です。</div> -->
                  <div class="error" v-if="!$v.linkTitle_chu_kan.maxLength">リンクタイトル(簡体字)は{{ $v.linkTitle_chu_kan.$params.maxLength.max }}文字以内で入力してください。</div>
                </div>
              </div>
            </td>
            <td class="td_head_url">URL</td>
            <td class="td_content_link_url">
              <input v-model.trim="$v.linkUrl_chu_kan.$model" type="text" class="text_link_url" v-bind:disabled="disabledFlg"/>
              <div class="message">
                <div v-if="$v.linkUrl_chu_kan.$dirty">
                  <!-- <div class="error" v-if="!$v.linkUrl.required">URLは必須入力です。</div> -->
                  <div class="error" v-if="!$v.linkUrl_chu_kan.url">URLを入力してください。</div>
                  <div class="error" v-if="!$v.linkUrl_chu_kan.maxLength">URLは{{ $v.linkUrl_chu_kan.$params.maxLength.max }}文字以内で入力してください。</div>
                </div>
              </div>
            </td>
          </tr>
          <tr v-if="this.$store.getters.getStateIsSoundAuth" class="tr_top">
            <td class="td_head_bottom">防災通知音を使用する</td>
            <td class="td_content_bottom" colspan="3">
              <input type="checkbox" v-model="soundFlg_chu_kan" class="check_sound" v-bind:disabled="disabledFlg">
            </td>
          </tr>
        </tbody>
      </table>
      <br>
      <br>
      <!-- jaのみ -->
      <table v-if="languageRadio == 1" class="tbl_main">
        <thead>
          <tr>
            <th class="th_message" colspan="4">災害発生予想日時</th>
          </tr>
        </thead>
        <tbody>
          <tr class="tr_top">
            <td class="td_head_top_disaster">災害発生予想日時を通知する</td>
            <td class="td_check_top" colspan="3">
              <input type="checkbox" v-model="disasterDatePushFlg" class="check_sound" v-bind:disabled="disabledFlg">
            </td>
          </tr>
          <tr class="tr_top">
            <td class="td_head_middle">災害種別</td>
            <td class="td_content_middle" colspan="3">
              <select class="disasterPull" v-model="disasterIdSelected" @change="selectedDisaster(disasterIdSelected)" :disabled="!disasterDatePushFlg || disabledFlg">
                <option v-for="disaster in disasters" v-bind:key="disaster.disaster_id" :value="disaster.disaster_id">{{ disaster.disaster_name }}</option>
              </select>
              <!-- <input v-model.trim="$v.pushTitle.$model" type="text" class="text_title" v-bind:disabled="disabledFlg" /> -->
              <div class="message">
                <div v-if="!$v.disasterIdSelected.$dirty">
                  <div class="error" v-if="!$v.disasterIdSelected.required">災害種別は必須入力です。</div>
                </div>
              </div>
            </td>
          </tr>
          <tr class="tr_top">
            <td class="td_head_bottom">日付</td>
            <td class="td_content_date">
              <div>
                <datepicker class="datepicker_disaster" v-model.trim="$v.disasterDate.$model" :format="DatePickerFormat" :language="ja" :highlighted="highlighted" :disabled="!disasterDatePushFlg || disabledFlg"></datepicker>
              </div>
              <!-- <input v-model.trim="$v.disasterDate.$model" type="text" class="text_link_title" v-bind:disabled="disabledFlg"/> -->
              <div class="message">
                <div v-if="!$v.disasterDate.$dirty">
                  <div class="error" v-if="!$v.disasterDate.isInvalid">日付は必須入力です。</div>
                </div>
              </div>
            </td>
            <td class="td_head_time">時間</td>
            <td class="td_content_time">
              <input placeholder="--時--分" class="display_time" type="text" v-model="disasterTimeHyphenFormat" :disabled="!disasterDatePushFlg || disabledFlg">
              <vue-timepicker ref="timepicker" input-width="135px" placeholder="--時--分" hour-label="時" minute-label="分" class="disaster_time" v-model.trim='$v.disasterTime.$model' :format="timeFormat" :disabled="!disasterDatePushFlg || disabledFlg"></vue-timepicker>
              <div class="message time_message">
                <div v-if="$v.disasterTime.$invalid">
                  <div class="error" v-if="!$v.disasterTime.isInvalid">時間は必須入力です。</div>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <br/>
      <br/>
      <!-- jaのみ -->
      <template v-if="languageRadio == 1">
        <div class="tab_message">※選択しているタブの内容で通知を行います。</div>
        <!-- 地域 -->
        <div>
          <div class="tabs">
            <div :class="[{'active': isTabActive===1}, 'tab']" v-on:click="changeTab(1)">地域</div>
            <div :class="[{'active': isTabActive===2}, 'tab']" v-on:click="changeTab(2)">グループ</div>
          </div>
        </div>
        <div v-if="isTabActive === 1">
          <table v-if="disasterDatePushFlg" >
            <thead>
              <tr>
                <th class="th_areas" colspan="2">送信する地域の追加</th>
              </tr>
              <tr>
                <th class="th_check">
                  <!-- <input type="checkbox" v-model="isAllSelected" class="check_area" v-bind:disabled="disabledFlg"> -->
                </th>
                <th class="th_area">地域名</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="area in areas" v-bind:key="area.id">
                <td>
                  <input type="checkbox" v-bind:value=area.area_id v-model="selectedAreas" class="check_area" v-bind:disabled="disasterAreas.indexOf(String(area.area_id)) == -1 || disabledFlg">
                </td>
                <td v-if="disasterAreas.indexOf(String(area.area_id)) == -1" class="area_name_disabled" disabled="true">{{ area.area_name }}</td>
                <td v-else class="area_name" disabled="true">{{ area.area_name }}</td>
              </tr>
            </tbody>
          </table>
          <table v-else>
            <thead>
              <tr>
                <th class="th_areas" colspan="2">送信する地域の追加</th>
              </tr>
              <tr>
                <th class="th_check">
                  <input type="checkbox" v-model="isAllSelected" class="check_area" v-bind:disabled="disabledFlg">
                </th>
                <th class="th_area">地域名</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="area in areas" v-bind:key="area.id">
                <td>
                  <input type="checkbox" v-bind:value=area.area_id v-model="selectedAreas" class="check_area" v-bind:disabled="disabledFlg">
                </td>
                <td class="area_name" disabled="true">{{ area.area_name }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- ここまで地域 -->
        <!-- グループ -->
        <div v-if="isTabActive === 2">
          <table v-if="disasterDatePushFlg">
            <thead>
              <tr>
                <th class="th_areas" colspan="2">送信するグループの追加</th>
              </tr>
              <tr>
                <th class="th_check">
                  <!-- <input type="checkbox" v-model="isAllSelected" class="check_area" v-bind:disabled="disabledFlg"> -->
                </th>
                <th class="th_area">グループ名</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="group in groups" v-bind:key="group.group_id">
                <td>
                  <input type="checkbox" v-bind:value=group.group_id v-model="selectedGroups" class="check_area" v-bind:disabled="group.areas.filter(gArea => disasterNonAreas.includes(gArea.area_id)).length != 0 || group.areas.length == 0 || disabledFlg">
                </td>
                <td v-if="group.areas.filter(gArea => disasterNonAreas.includes(gArea.area_id)).length != 0 || disasterAreas.length ==0 || group.areas.length == 0" class="area_name_disabled" disabled="true">{{ group.group_name }}</td>
                <td v-else class="area_name" disabled="true">
                  {{ group.group_name }}
                  <span class="group_link" v-on:click="modalGroupAreas(group)">登録されている地域</span>
                  <modal :name="'modal_group_areas_'+group.group_id" :draggable="false" :resizable="false" :scrollable="true" :height="auto">
                    <div class="modal_header_group">
                      <p class="modal_title_group">{{ group.group_name }}に登録されている地域</p>
                    </div>
                    <div class="modal-body_group">
                      <ul v-for="area in group.areas" :key="area.area_id">
                        <li>{{ area.area_name }}</li>
                      </ul>
                    </div>
                    <div class="modal-btn_group">
                      <div class="modal_btn_div_group">
                        <button class="btn btn-outline-primary" @click="close_modal_group_areas(group)">閉じる</button>
                      </div>
                    </div>  
                  </modal>
                </td>
              </tr>
            </tbody>
          </table>
          <table v-else>
            <thead>
              <tr>
                <th class="th_areas" colspan="2">送信するグループの追加</th>
              </tr>
              <tr>
                <th class="th_check">
                  <input type="checkbox" v-model="isAllGroupSelected" class="check_area" v-bind:disabled="disabledFlg">
                </th>
                <th class="th_area">グループ名</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="group in groups" v-bind:key="group.group_id">
                <td>
                  <input type="checkbox" v-bind:value=group.group_id v-model="selectedGroups" class="check_area" v-bind:disabled="disabledFlg || group.areas.length == 0">
                </td>
                <td v-if="group.areas.length == 0" class="area_name_disabled" disabled="true">{{ group.group_name }}</td>
                <td v-else class="area_name" disabled="true">
                  <span>{{ group.group_name }}</span>
                  <span class="group_link" v-on:click="modalGroupAreas(group)">登録されている地域</span>
                  <modal :name="'modal_group_areas_'+group.group_id" 
                    :draggable="false" 
                    :resizable="false" 
                    :scrollable="true" 
                    height="auto">
                    <div class="modal_header_group">
                      <p class="modal_title_group">{{ group.group_name }}に登録されている地域</p>
                    </div>
                    <div class="modal-body_group">
                      <ul v-for="area in group.areas" :key="area.area_id">
                        <li>{{ area.area_name }}</li>
                      </ul>
                    </div>
                    <div class="modal-btn_group">
                      <div class="modal_btn_div_group">
                        <button class="btn btn-outline-primary" @click="close_modal_group_areas(group)">閉じる</button>
                      </div>
                    </div>  
                  </modal>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- ここまでグループ -->
        <br/>
        <br/>
      </template>
      <table>
        <thead>
          <tr>
            <th class="th_preview">プレビュー</th>
          </tr>
        </thead>
        <!-- ja -->
        <tbody v-if="languageRadio == 1">
          <tr>
            <td class="preview_image">
              <span class="ios_preview">iOS</span>
              <div id="ios" class="disp">
                <div id="ios_push">
                  <div id="ios_bar">
                    <img id="ios_icon" v-bind:src="iconImage">
                    <span class="ios_notification">防災サポート</span>
                    <span class="ios_batsu">×</span>
                  </div>
                  <span class="ios_title">訓練:{{ $v.pushTitle.$model }}</span>
                  <span class="ios_message">{{ $v.pushMessage.$model | truncate(100, '...') }}</span>
                  <!-- <span v-if="disasterDatePushFlg" class="ios_message">{{ disasterName }}の到達日時をお知らせします。</span> -->
                  <span v-if="disasterDatePushFlg" class="ios_message">災害発生予想日時: {{ disasterDate == "" ? disasterDate = "" : dateFormat(disasterDate, languageRadio) }}{{disasterTime == "" ? disasterTime = "" : disasterTimeFormat(disasterTime, languageRadio) }}</span>
                </div>
              </div>
              <span class="android_preview">Android</span>
              <div id="android" class="disp">
                <div id="android_push">
                  <div id="android_icon">
                    <img class="android_icon" v-bind:src="iconImage">
                  </div>
                  <div id="android_title">
                    <span class="android_title">訓練:{{ $v.pushTitle.$model }}</span>
                    <span class="android_time">現在</span>
                  </div>
                  <span class="android_message">{{ $v.pushMessage.$model | truncate(100, '...') }}</span>
                  <!-- <span v-if="disasterDatePushFlg" class="android_message">{{ disasterName }}の到達日時をお知らせします。</span> -->
                  <span v-if="disasterDatePushFlg" class="android_message">災害発生予想日時: {{ disasterDate == "" ? disasterDate = "" : dateFormat(disasterDate, languageRadio) }}{{ disasterTimeFormat(disasterTime, languageRadio) }}</span>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
        <!-- engliah -->
        <tbody v-if="languageRadio == 2">
          <tr>
            <td class="preview_image">
              <span class="ios_preview">iOS</span>
              <div id="ios" class="disp">
                <div id="ios_push">
                  <div id="ios_bar">
                    <img id="ios_icon" v-bind:src="iconImage">
                    <span class="ios_notification">防災サポート</span>
                    <span class="ios_batsu">×</span>
                  </div>
                  <span class="ios_title">{{ $v.pushTitle_ei.$model }}</span>
                  <span class="ios_message">{{ $v.pushMessage_ei.$model | truncate(100, '...') }}</span>
                  <!-- <span v-if="disasterDatePushFlg" class="ios_message">{{ disasterName }}の到達日時をお知らせします。</span> -->
                  <span v-if="disasterDatePushFlg" class="ios_message">Estimated disaster occurrence date and time: {{ disasterDate == "" ? disasterDate = "" : dateFormat(disasterDate, languageRadio) }}{{ disasterTimeFormat(disasterTime, languageRadio) }}</span>
                </div>
              </div>
              <span class="android_preview">Android</span>
              <div id="android" class="disp">
                <div id="android_push">
                  <div id="android_icon">
                    <img class="android_icon" v-bind:src="iconImage">
                  </div>
                  <div id="android_title">
                    <span class="android_title">{{ $v.pushTitle_ei.$model }}</span>
                    <span class="android_time">現在</span>
                  </div>
                  <span class="android_message">{{ $v.pushMessage_ei.$model | truncate(100, '...') }}</span>
                  <!-- <span v-if="disasterDatePushFlg" class="android_message">{{ disasterName }}の到達日時をお知らせします。</span> -->
                  <span v-if="disasterDatePushFlg" class="android_message">Estimated disaster occurrence date and time: {{ disasterDate == "" ? disasterDate = "" : dateFormat(disasterDate, languageRadio) }}{{ disasterTimeFormat(disasterTime, languageRadio) }}</span>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
        <!-- 韓国語 -->
        <tbody v-if="languageRadio == 3">
          <tr>
            <td class="preview_image">
              <span class="ios_preview">iOS</span>
              <div id="ios" class="disp">
                <div id="ios_push">
                  <div id="ios_bar">
                    <img id="ios_icon" v-bind:src="iconImage">
                    <span class="ios_notification">防災サポート</span>
                    <span class="ios_batsu">×</span>
                  </div>
                  <span class="ios_title">{{ $v.pushTitle_kan.$model }}</span>
                  <span class="ios_message">{{ $v.pushMessage_kan.$model | truncate(100, '...') }}</span>
                  <!-- <span v-if="disasterDatePushFlg" class="ios_message">{{ disasterName }}の到達日時をお知らせします。</span> -->
                  <span v-if="disasterDatePushFlg" class="ios_message">재난발생 예상일시 : {{ disasterDate == "" ? disasterDate = "" : dateFormat(disasterDate, languageRadio) }}{{ disasterTimeFormat(disasterTime, languageRadio) }}</span>
                </div>
              </div>
              <span class="android_preview">Android</span>
              <div id="android" class="disp">
                <div id="android_push">
                  <div id="android_icon">
                    <img class="android_icon" v-bind:src="iconImage">
                  </div>
                  <div id="android_title">
                    <span class="android_title">{{ $v.pushTitle_kan.$model }}</span>
                    <span class="android_time">現在</span>
                  </div>
                  <span class="android_message">{{ $v.pushMessage_kan.$model | truncate(100, '...') }}</span>
                  <!-- <span v-if="disasterDatePushFlg" class="android_message">{{ disasterName }}の到達日時をお知らせします。</span> -->
                  <span v-if="disasterDatePushFlg" class="android_message">재난발생 예상일시 : {{ disasterDate == "" ? disasterDate = "" : dateFormat(disasterDate, languageRadio) }}{{ disasterTimeFormat(disasterTime, languageRadio) }}</span>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
        <!-- 中国語:繁体字 -->
        <tbody v-if="languageRadio == 4">
          <tr>
            <td class="preview_image">
              <span class="ios_preview">iOS</span>
              <div id="ios" class="disp">
                <div id="ios_push">
                  <div id="ios_bar">
                    <img id="ios_icon" v-bind:src="iconImage">
                    <span class="ios_notification">防災サポート</span>
                    <span class="ios_batsu">×</span>
                  </div>
                  <span class="ios_title">{{ $v.pushTitle_chu_han.$model }}</span>
                  <span class="ios_message">{{ $v.pushMessage_chu_han.$model | truncate(100, '...') }}</span>
                  <!-- <span v-if="disasterDatePushFlg" class="ios_message">{{ disasterName }}の到達日時をお知らせします。</span> -->
                  <span v-if="disasterDatePushFlg" class="ios_message">預計災害發生日期和時間: {{ disasterDate == "" ? disasterDate = "" : dateFormat(disasterDate, languageRadio) }}{{ disasterTimeFormat(disasterTime, languageRadio) }}</span>
                </div>
              </div>
              <span class="android_preview">Android</span>
              <div id="android" class="disp">
                <div id="android_push">
                  <div id="android_icon">
                    <img class="android_icon" v-bind:src="iconImage">
                  </div>
                  <div id="android_title">
                    <span class="android_title">{{ $v.pushTitle_chu_han.$model }}</span>
                    <span class="android_time">現在</span>
                  </div>
                  <span class="android_message">{{ $v.pushMessage_chu_han.$model | truncate(100, '...') }}</span>
                  <!-- <span v-if="disasterDatePushFlg" class="android_message">{{ disasterName }}の到達日時をお知らせします。</span> -->
                  <span v-if="disasterDatePushFlg" class="android_message">預計災害發生日期和時間: {{ disasterDate == "" ? disasterDate = "" : dateFormat(disasterDate, languageRadio) }}{{ disasterTimeFormat(disasterTime, languageRadio) }}</span>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
        <!-- 中国語:簡体字 -->
        <tbody v-if="languageRadio == 5">
          <tr>
            <td class="preview_image">
              <span class="ios_preview">iOS</span>
              <div id="ios" class="disp">
                <div id="ios_push">
                  <div id="ios_bar">
                    <img id="ios_icon" v-bind:src="iconImage">
                    <span class="ios_notification">防災サポート</span>
                    <span class="ios_batsu">×</span>
                  </div>
                  <span class="ios_title">{{ $v.pushTitle_chu_kan.$model }}</span>
                  <span class="ios_message">{{ $v.pushMessage_chu_kan.$model | truncate(100, '...') }}</span>
                  <!-- <span v-if="disasterDatePushFlg" class="ios_message">{{ disasterName }}の到達日時をお知らせします。</span> -->
                  <span v-if="disasterDatePushFlg" class="ios_message">预计灾害发生日期和时间: {{ disasterDate == "" ? disasterDate = "" : dateFormat(disasterDate, languageRadio) }}{{ disasterTimeFormat(disasterTime, languageRadio) }}</span>
                </div>
              </div>
              <span class="android_preview">Android</span>
              <div id="android" class="disp">
                <div id="android_push">
                  <div id="android_icon">
                    <img class="android_icon" v-bind:src="iconImage">
                  </div>
                  <div id="android_title">
                    <span class="android_title">{{ $v.pushTitle_chu_kan.$model }}</span>
                    <span class="android_time">現在</span>
                  </div>
                  <span class="android_message">{{ $v.pushMessage_chu_kan.$model | truncate(100, '...') }}</span>
                  <!-- <span v-if="disasterDatePushFlg" class="android_message">{{ disasterName }}の到達日時をお知らせします。</span> -->
                  <span v-if="disasterDatePushFlg" class="android_message">预计灾害发生日期和时间: {{ disasterDate == "" ? disasterDate = "" : dateFormat(disasterDate, languageRadio) }}{{ disasterTimeFormat(disasterTime, languageRadio) }}</span>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <br/>
    </div>
  </div>
</template>

<script>
import { required, maxLength, url, requiredIf } from 'vuelidate/lib/validators'
import IconImage from "@/img/push_icon.png";
import Datepicker from 'vuejs-datepicker'
import {ja} from 'vuejs-datepicker/dist/locale'
import VueTimepicker from 'vue2-timepicker'
import 'vue2-timepicker/dist/VueTimepicker.css'

import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

import mixinFilters from './mixin/filters'

export default {
  components: {
    Datepicker,
    VueTimepicker,
    "loading":Loading
  },
  mixins: [ mixinFilters ],
  data: function() {
    return {
      areas: null,
      areasAll: [],
      groups: [],
      groupsAll: [],
      // 画面表示項目
      notificationName: "",
      pushTitle: "",
      pushTitle_ei: "",
      pushTitle_kan: "",
      pushTitle_chu_han: "",
      pushTitle_chu_kan: "",
      pushMessage: "",
      pushMessage_ei: "",
      pushMessage_kan: "",
      pushMessage_chu_han: "",
      pushMessage_chu_kan: "",
      linkTitle: "",
      linkTitle_ei: "",
      linkTitle_kan: "",
      linkTitle_chu_han: "",
      linkTitle_chu_kan: "",
      linkUrl: "",
      linkUrl_ei: "",
      linkUrl_kan: "",
      linkUrl_chu_han: "",
      linkUrl_chu_kan: "",
      soundFlg: false,
      soundFlg_ei: false,
      soundFlg_kan: false,
      soundFlg_chu_han: false,
      soundFlg_chu_kan: false,
      status: 0,
      selectedAreas: [],
      disasterAreas: [],
      disasterNonAreas: [],
      disasterDatePushFlg: false,
      templateFlg: "",

      selectedGroups: [],

      disasterIdSelected: "",
      disasterName: "",
      disasterDate: "",
      disasterTime: "",

      languageRadio: 1,

      isTabActive: 1,

      unfilledPushLanguageStr: "",

      languages: "",
      primaryLanguageId: "",
     
     // 日付入力カレンダー
      ja: ja,
      DatePickerFormat: 'yyyy年MM月dd日',
      highlighted: {
        dates: [new Date(),]
      },
      // timepicker
      timeFormat: 'HH時mm分',

      // 変更フラグ
      changeFlg: false,
      // 非活性フラグ
      disabledFlg: false,
      // メッセージ
      message: "",
      // アイコン画像
      iconImage: IconImage,
      disasters: null,
      isLoading: false,
      fullPage: true,
      updating: false,
    }
  },
  mounted() {
    // 変更フラグ
    this.changeFlg = this.$store.getters.getStateChangeFlg
    // テンプレートフラグ
    this.templateFlg = this.$store.getters.getStateTemplateFlg

    // 自治体情報:プライマリー言語
    this.getMunicipality()
    // 災害種別取得
    this.getDisasterType()

    // 変更の場合は詳細情報取得
    if (this.changeFlg) {
      this.pushDetail()
    }
    // 地域取得
    this.getAreaList()
    // 地域グループ
    this.getGroupList()
    
    this.$refs.timepicker.$refs.input.style.opacity = 0
  },
  methods: {
    onCancel:function() {
      console.log('User cancelled the loader.')
    },
    async getMunicipality() {
      try {
        const response = await this.$axios.get(process.env.VUE_APP_API_BASEURL + 'primary-language/detail', {
          params: {
            municipality_key: this.$store.getters.getStateMunicipalityKey
          }
        })
        this.languages = response.data.language
        this.primaryLanguageId = response.data.municipality[0].primary_language

        console.log("primary : " + this.primaryLanguageId)

        this.message = ""

      } catch (err) {
        this.message = err.response.data.errorMessage
      }
    },
    async getDisasterType() {
      const response = await this.$axios.get(process.env.VUE_APP_API_BASEURL + 'disaster/list', {
        params: {
          municipality_key: this.$store.getters.getStateMunicipalityKey
        }
      })
      this.disasters = response.data
    },
    async getAreaList() {
      const response = await this.$axios.get(process.env.VUE_APP_API_BASEURL + 'area/list', {
        params: {
          municipality_key: this.$store.getters.getStateMunicipalityKey
          , action_name: "municipality_area_list"
        }
      })
      this.areas = response.data

      // チェックボックス全選択用
      for (var i= 0; i< this.areas.length; i++) {
        this.areasAll.push(this.areas[i].area_id)
      }
      // for (var groupIndex= 0; groupIndex< this.groups.length; groupIndex++) {
      //   this.groupsAll.push(this.groups[groupIndex].group_id)
      // }

      // 変更の場合は詳細情報取得
      if (this.changeFlg) {
        this.pushDetail()
      }
    },
    async getGroupList() {
      const response = await this.$axios.get(process.env.VUE_APP_API_BASEURL + 'area-group/list', {
        params: {
          municipality_key: this.$store.getters.getStateMunicipalityKey
          , action_name: "group_areas"
        }
      })
      this.groups = response.data

      // チェックボックス全選択用
      for (var i= 0; i< this.groups.length; i++) {
        if (this.groups[i].areas.length != 0) {
          this.groupsAll.push(this.groups[i].group_id)
        }
      }
      // 変更の場合は詳細情報取得
      if (this.changeFlg) {
        this.pushDetail()
      }
    },
    async pushDetail() {
      const response = await this.$axios.get(process.env.VUE_APP_API_BASEURL + 'push-training/pushdetail', {
        params: {
          push_id: this.$store.getters.getStatePushId,
          municipality_key: this.$store.getters.getStateMunicipalityKey
        }
      })
      
      this.notificationName = response.data[0].notification_name
      this.pushTitle = response.data[0].push_title
      this.pushTitle_ei = response.data[0].push_title_ei
      this.pushTitle_kan = response.data[0].push_title_kan
      this.pushTitle_chu_han = response.data[0].push_title_chu_han
      this.pushTitle_chu_kan = response.data[0].push_title_chu_kan
      this.pushMessage = response.data[0].push_message
      this.pushMessage_ei = response.data[0].push_message_ei
      this.pushMessage_kan = response.data[0].push_message_kan
      this.pushMessage_chu_han = response.data[0].push_message_chu_han
      this.pushMessage_chu_kan = response.data[0].push_message_chu_kan
      this.linkTitle = response.data[0].link_title
      this.linkTitle_ei = response.data[0].link_title_ei
      this.linkTitle_kan = response.data[0].link_title_kan
      this.linkTitle_chu_han = response.data[0].link_title_chu_han
      this.linkTitle_chu_kan = response.data[0].link_title_chu_kan
      this.linkUrl = response.data[0].link_url
      this.linkUrl_ei = response.data[0].link_url_ei
      this.linkUrl_kan = response.data[0].link_url_kan
      this.linkUrl_chu_han = response.data[0].link_url_chu_han
      this.linkUrl_chu_kan = response.data[0].link_url_chu_kan
      response.data[0].sound_flg == 1 ? this.soundFlg = true : this.soundFlg = false
      response.data[0].sound_flg_ei == 1 ? this.soundFlg_ei = true : this.soundFlg_ei = false
      response.data[0].sound_flg_kan == 1 ? this.soundFlg_kan = true : this.soundFlg_kan = false
      response.data[0].sound_flg_chu_han == 1 ? this.soundFlg_chu_han = true : this.soundFlg_chu_han = false
      response.data[0].sound_flg_chu_kan == 1 ? this.soundFlg_chu_kan = true : this.soundFlg_chu_kan = false
      this.status = response.data[0].status
      this.selectedAreas = response.data[0].areas
      this.selectedGroups = response.data[0].groups
      this.disasterDatePushFlg = response.data[0].disaster_push_flg === true ? false : response.data[0].disaster_push_flg

      if (response.data[0].disaster_id != true && response.data[0].disaster_id != null) {
        this.disasterIdSelected = response.data[0].disaster_id
        if (this.disasterDatePushFlg) {
          this.selectedDisaster(this.disasterIdSelected)
        }
      }
      this.disasterDate = response.data[0].disaster_push_datetime != true ? this.$moment(response.data[0].disaster_push_datetime).format('YYYY-MM-DD') : ""
      this.disasterTime = response.data[0].disaster_push_datetime != true ? this.$moment(response.data[0].disaster_push_datetime).format('HH時mm分') : ""
      this.isTabActive = response.data[0].tab_active

      // 非活性フラグ
      this.status==1 ? this.disabledFlg = true : this.disabledFlg = false

      // check municipality areas
      console.log("pre selected areas")
      console.log(this.selectedAreas)
      console.log(this.areas)
      let municipalityAreas = this.areas.map(x => x.area_id)
      console.log(municipalityAreas)
      let selectedAreasSet = new Set(this.selectedAreas)
      this.selectedAreas = municipalityAreas.filter(x => selectedAreasSet.has(x))
      console.log("post selected areas")
      console.log(this.selectedAreas)

      // check municipality groups
      console.log("groups")
      console.log(this.groups)
      console.log("pre selected groups")
      console.log(this.selectedGroups)
      const municipalityGroups = this.groups.map(x => x.group_id)
      const selectedGroupsSet = new Set(this.selectedGroups)
      this.selectedGroups = municipalityGroups.filter(x => selectedGroupsSet.has(x))
      console.log("post selected groups")
      console.log(this.selectedGroups)
    },
    async pushAdd(templateFlg) {
      this.updating = true;
      var disasterDatetime

      if (this.disasterDate != "" && this.disasterTime != "") {
        disasterDatetime = this.$moment(this.disasterDate).format('YYYY-MM-DD') + " " + this.timeFormatForPush(this.disasterTime) + ":00"
      } else {
        disasterDatetime = null
      }
      
      try {
        await this.$axios.post(process.env.VUE_APP_API_BASEURL + 'push-training/pushadd', {
          municipality_key: this.$store.getters.getStateMunicipalityKey,
          notification_name: this.notificationName,
          push_title: this.pushTitle,
          push_title_ei: this.pushTitle_ei,
          push_title_kan: this.pushTitle_kan,
          push_title_chu_han: this.pushTitle_chu_han,
          push_title_chu_kan: this.pushTitle_chu_kan,
          push_message: this.pushMessage,
          push_message_ei: this.pushMessage_ei,
          push_message_kan: this.pushMessage_kan,
          push_message_chu_han: this.pushMessage_chu_han,
          push_message_chu_kan: this.pushMessage_chu_kan,
          link_title: this.linkTitle,
          link_title_ei: this.linkTitle_ei,
          link_title_kan: this.linkTitle_kan,
          link_title_chu_han: this.linkTitle_chu_han,
          link_title_chu_kan: this.linkTitle_chu_kan,
          link_url: this.linkUrl,
          link_url_ei: this.linkUrl_ei,
          link_url_kan: this.linkUrl_kan,
          link_url_chu_han: this.linkUrl_chu_han,
          link_url_chu_kan: this.linkUrl_chu_kan,
          sound_flg: this.soundFlg,
          sound_flg_ei: this.soundFlg_ei,
          sound_flg_kan: this.soundFlg_kan,
          sound_flg_chu_han: this.soundFlg_chu_han,
          sound_flg_chu_kan: this.soundFlg_chu_kan,
          selected_areas: this.selectedAreas,
          selected_groups: this.selectedGroups,
          charge_id: this.$store.getters.getStateChargeId,
          push_training_id: this.$store.getters.getStatePushTrainingId,
          disaster_push_flg: this.disasterDatePushFlg,
          disaster_id: this.disasterDatePushFlg ? this.disasterIdSelected : null,
          disaster_push_datetime: this.disasterDatePushFlg ? disasterDatetime : null,
          template_flg: templateFlg == 1 ? 1 : null,
          tab_active: this.isTabActive
        })
        // テンプレート画面に戻す
        if (templateFlg == 1) {
          this.$store.commit('setStatePushTemplateUpdateFlg', 1)
        }
        console.log("detail画面: " + this.$store.getters.getStatePushTemplateUpdateFlg)

        this.$router.push('/pushNotificationTrainingList')
      } catch (err) {
        this.message = err.response.data.errorMessage
      }
      this.updating = false;
    },
    async pushUpdate(status,templateFlg) {
      this.updating = true;
      var disasterDatetime

      if (this.disasterDate != "" && this.disasterTime != "" && this.disasterDate.toString() != "Invalid date" && this.disasterTime.toString() != "Invalid date") {
        disasterDatetime = this.$moment(this.disasterDate).format('YYYY-MM-DD') + " " + this.timeFormatForPush(this.disasterTime) + ":00"
      } else {
        disasterDatetime = null
      }

      try {
        if (status == 1) {
          this.isLoading = true;
        }

        await this.$axios.post(process.env.VUE_APP_API_BASEURL + 'push-training/pushupdate', {
          push_id: this.changeFlg ? this.$store.getters.getStatePushId : "add",
          municipality_key: this.$store.getters.getStateMunicipalityKey,
          notification_name: this.notificationName,
          push_title: this.pushTitle,
          push_title_ei: this.pushTitle_ei,
          push_title_kan: this.pushTitle_kan,
          push_title_chu_han: this.pushTitle_chu_han,
          push_title_chu_kan: this.pushTitle_chu_kan,
          push_message: this.pushMessage,
          push_message_ei: this.pushMessage_ei,
          push_message_kan: this.pushMessage_kan,
          push_message_chu_han: this.pushMessage_chu_han,
          push_message_chu_kan: this.pushMessage_chu_kan,
          link_title: this.linkTitle,
          link_title_ei: this.linkTitle_ei,
          link_title_kan: this.linkTitle_kan,
          link_title_chu_han: this.linkTitle_chu_han,
          link_title_chu_kan: this.linkTitle_chu_kan,
          link_url: this.linkUrl,
          link_url_ei: this.linkUrl_ei,
          link_url_kan: this.linkUrl_kan,
          link_url_chu_han: this.linkUrl_chu_han,
          link_url_chu_kan: this.linkUrl_chu_kan,
          sound_flg: this.soundFlg,
          sound_flg_ei: this.soundFlg_ei,
          sound_flg_kan: this.soundFlg_kan,
          sound_flg_chu_han: this.soundFlg_chu_han,
          sound_flg_chu_kan: this.soundFlg_chu_kan,
          status: status,
          selected_areas: this.selectedAreas,
          selected_groups: this.selectedGroups,
          charge_id: this.$store.getters.getStateChargeId,
          training_id: this.$store.getters.getStatePushTrainingId,
          disaster_push_flg: this.disasterDatePushFlg,
          disaster_id: this.disasterDatePushFlg ? this.disasterIdSelected : null,
          disaster_push_datetime: this.disasterDatePushFlg ? disasterDatetime : null,
          tab_active: this.isTabActive,
          primary_language_id: this.primaryLanguageId,
          languages: this.languages,
          template_flg: templateFlg == 1 ? 1 : null
        })

        if (status == 1) {
          this.isLoading = false;
        }

        this.$router.push('/pushNotificationTrainingList')
      } catch (err) {
        console.log(err)
        this.message = err.response.data.errorMessage
      }
      this.updating = false;
    },
    pushSave: function(templateFlg) {
      // テンプレート画面に戻す
      if (templateFlg == 1) {
        this.$store.commit('setStatePushTemplateUpdateFlg', 1)
      }

      // pushUpdateの引数が0の場合は更新のみ。プッシュ送信は行わない。
      this.pushUpdate(0, templateFlg)
    },
    pushRelease: function(templateFlg) {
      // pushUpdateの引数が1の場合はプッシュ送信を行う。同時に更新も行う。
      this.pushUpdate(1, templateFlg)
    },
    dateFormat: function(value, languageRadio) {
      var resultDateStr = ""
      
      if (value == "Invalid date" || value == "") {
        return
      }

      if (languageRadio == 1) {
        resultDateStr = this.$moment(value).format('YYYY年MM月DD日 ')
      } else if (languageRadio == 2) {
        resultDateStr = this.$moment(value).format('MMM') + " " + this.$moment(value).format('DD') + ", " + this.$moment(value).format('YYYY') + " "
      } else if (languageRadio == 3) {
        resultDateStr = this.$moment(value).format('YYYY') + "년" + this.$moment(value).format('MM') + "월" + this.$moment(value).format('DD') + "일 "
      } else {
        resultDateStr = this.$moment(value).format('YYYY年MM月DD日 ')
      }

      return resultDateStr
    },
    disasterTimeFormat: function(value, languageRadio) {
      var resultTimeStr = ""

      if (value == "Invalid date" || value == "") {
        return
      }

      if (languageRadio == 1) {
        resultTimeStr = this.$moment(value, 'HH時mm分').format('HH時mm分')
      } else if (languageRadio == 2) {
        resultTimeStr = this.$moment(value, 'HH時mm分').format('HH:mm')
      } else if (languageRadio == 3) {
        resultTimeStr = this.$moment(value, 'HH時mm分').format('HH시mm분')
      } else {
        resultTimeStr = this.$moment(value, 'HH時mm分').format('HH時mm分')
      }


      return resultTimeStr
    },
    timeFormatForPush: function(value) {
      return this.$moment(value, 'HH時mm分').format('HH:mm')
    },
    async selectedDisaster(disasterId) {
      const response = await this.$axios.get(process.env.VUE_APP_API_BASEURL + 'disaster/detail', {
        params: {
          municipality_key: this.$store.getters.getStateMunicipalityKey,
          disaster_id: disasterId
        }
      })

      this.disasterAreas = response.data[0].area_id
      this.disasterName = response.data[0].disaster_name
            
      this.selectedAreas = this.selectedAreas.filter(area => {
        return this.disasterAreas.indexOf(String(area)) != -1
      })

      this.disasterNonAreas = this.areas.filter(area => {
        return this.disasterAreas.indexOf(String(area.area_id)) == -1
      }).map(a => a.area_id)

    },
    open_modal_release: function() {
      // 地域が1件も選択されていない場合はエラーとする。
      if (this.isTabActive == 1 && this.selectedAreas.length == 0) {
        this.message = "送信する地域を選択してください。"
        return
      } else if (this.isTabActive == 2 && this.selectedGroups.length == 0) {
        this.message = "送信するグループを選択してください。"
        return
      } else {
        this.message = ""
      }

      this.getUnfilledItems()
      this.$modal.show("modal_release")
    },
    close_modal_release: function() {
      this.$modal.hide("modal_release")
    },
    modalGroupAreas: function(group) {
      this.$modal.show("modal_group_areas_" + group.group_id)
    },
    close_modal_group_areas: function(group) {
      this.$modal.hide("modal_group_areas_" + group.group_id)
    },
    changeTab: function(tabNo) {
      this.isTabActive = tabNo
    },
    getUnfilledItems() {
      var itemList = []
      
      if (this.checkLanguage(2) == false) {
        itemList.push("英語")
      }
      if (this.checkLanguage(3) == false) {
        itemList.push("韓国語")
      }
      if (this.checkLanguage(4) == false) {
        itemList.push("中国語(繁体字)")
      }
      if (this.checkLanguage(5) == false) {
        itemList.push("中国語(簡体字)")
      }

      this.unfilledPushLanguageStr = itemList.join(",")
    },
    checkPrimary() {
      var resultLanguage = "日本語"

      if (this.primaryLanguageId == 2) {
        if (this.checkLanguage(2) == true) {
          resultLanguage = "英語"
        }
      } else if (this.primaryLanguageId == 3) {
        if (this.checkLanguage(3) == true) {
          resultLanguage = "韓国語"
        }
      } else if (this.primaryLanguageId == 4) {
        if (this.checkLanguage(4) == true) {
          resultLanguage = "中国語(繁体字)"
        }
      } else if (this.primaryLanguageId == 5) {
        if (this.checkLanguage(5) == true) {
          resultLanguage = "中国語(簡体字)"
        }
      }

      console.log("checkPrimary")

      return resultLanguage
    },
    checkLanguage(languageId) {
      var resultFlg = false

      if (languageId == 2) {
        if (this.pushTitle_ei == "" || this.pushTitle_ei == null || this.pushMessage_ei == "" || this.pushMessage_ei == null) {
          resultFlg = false
        } else {
          resultFlg = true
        }
      } else if (languageId == 3) {
        // console.log(this.pushTitle_kan)
        if (this.pushTitle_kan == "" || this.pushTitle_kan == null || this.pushMessage_kan == "" || this.pushMessage_kan == null) {
          resultFlg = false
        } else {
          resultFlg = true
        }
      } else if (languageId == 4) {
        if (this.pushTitle_chu_han == "" || this.pushTitle_chu_han == null || this.pushMessage_chu_han == "" || this.pushMessage_chu_han == null) {
          resultFlg = false
        } else {
          resultFlg = true
        }
      } else if (languageId == 5) {
        if (this.pushTitle_chu_kan == "" || this.pushTitle_chu_kan == null || this.pushMessage_chu_kan == "" || this.pushMessage_chu_kan == null) {
          resultFlg = false
        } else {
          resultFlg = true
        }
      }

      return resultFlg
    },
    changeLanguage() {
      if (this.languageRadio == 1) {
        this.$nextTick(function() {
          // console.log(this.$refs.timepicker)
          this.$refs.timepicker.$refs.input.style.opacity = 0
        })
      }
    },
  },
  computed: {
    isAllSelected: {
      get: function () {
        return this.areas ? this.areas.length == this.selectedAreas.length : false;
      },
      set: function (checked) {
        this.selectedAreas = checked ? this.areasAll : []
      }
    },
    isOptional() {
      return true
    },
    isAllGroupSelected: {
      get: function () {
        return this.groups ? this.groups.length == this.selectedGroups.length : false
      },
      set: function (checked) {
        this.selectedGroups = checked ? this.groupsAll : []
      }
    },
    disasterTimeHyphenFormat: {
      get: function () {
        if (this.disasterTime == 'Invalid date') return '--時--分'
        return this.disasterTime.replace(/HH|mm/g, '--')
      },
      set: function(val) {
        this.disasterTimeHyphenStr = val.replace('mm', '--')
      }
    },
  },
  watch: {
    // isAllGroupSelected: function() {
    //   if (this.groupsAll == this.selectedGroups) {
    //     return true
    //   }
    // }
  //   disasterDatePushFlg: function(val) {
  //     if (val == true) {
  //       this.selectedDisaster(this.disasterIdSelected)
  //     }
  //   }
  },
  validations() {
    return {
      notificationName: {
        required,
        maxLength: maxLength(50)
      },
      pushTitle: {
        required,
        maxLength: maxLength(50)
      },
      pushTitle_ei: {
        maxLength: maxLength(50)
      },
      pushTitle_kan: {
        maxLength: maxLength(50)
      },
      pushTitle_chu_han: {
        maxLength: maxLength(50)
      },
      pushTitle_chu_kan: {
        maxLength: maxLength(50)
      },
      pushMessage: {
        required,
        maxLength: maxLength(300)
      },
      pushMessage_ei: {
        maxLength: maxLength(300)
      },
      pushMessage_kan: {
        maxLength: maxLength(300)
      },
      pushMessage_chu_han: {
        maxLength: maxLength(300)
      },
      pushMessage_chu_kan: {
        maxLength: maxLength(300)
      },
      linkTitle: {
        maxLength: maxLength(30)
      },
      linkTitle_ei: {
        maxLength: maxLength(30)
      },
      linkTitle_kan: {
        maxLength: maxLength(30)
      },
      linkTitle_chu_han: {
        maxLength: maxLength(30)
      },
      linkTitle_chu_kan: {
        maxLength: maxLength(30)
      },
      linkUrl: {
        maxLength: maxLength(400),
        url
      },
      linkUrl_ei: {
        maxLength: maxLength(400),
        url
      },
      linkUrl_kan: {
        maxLength: maxLength(400),
        url
      },
      linkUrl_chu_han: {
        maxLength: maxLength(400),
        url
      },
      linkUrl_chu_kan: {
        maxLength: maxLength(400),
        url
      },
      disasterIdSelected: {
        required: requiredIf(function () {
          return this.disasterDatePushFlg
        }),
      },
      disasterDate: {
        required: requiredIf(function () {
          return this.disasterDatePushFlg
        }),
        isInvalid(value) {
          return (this.disasterDatePushFlg && value == 'Invalid date') ? false : true
        }
      },
      disasterTime: {
        required: requiredIf(function () {
          return this.disasterDatePushFlg
        }),
        isInvalid(value) {
          var pattern =  /^\d{2}時\d{2}分$/g
          if (this.disasterDatePushFlg) {
            return (value == 'Invalid date' || value.match(pattern) == null) ? false : true
          } else {
            return true
          }
        }
      }
    }
  }
}
</script>

<style scoped>
.area_radios_div {
  display: flex;
  margin: 0 0 0 30px;
}
.area_radio_div {
  margin: 0 10px 0 0;
  font-size: smaller;
}
.area_radio_label {
  margin: 2px 0 0 0;
}
.tbl_main {
  background-color: white;
}
.btn_general {
  margin-left: 5px;
}
table th.th_areas, th.th_preview {
  width: 800px;
}
table th.th_message, .th_areas, .th_area, .th_preview {
  text-align: left;
  padding-left: 10px; 
}
table th.th_check {
  width: 30px;
}
table tr {
  border: none;
}
table tr.tr_top td {
  border: none;
}

table td.td_head_top {
  text-align: left;
  padding: 20px 0px 20px 20px;
  width: 150px;
}
table td.td_head_middle {
  text-align: left;
  padding: 0px 0px 20px 20px;
  width: 150px;
}
table td.td_head_bottom {
  text-align: left;
  padding: 0px 0px 20px 20px;
  width: 150px;
}
table td.td_head_url {
  text-align: right;
  padding: 0px 0px 20px 10px;
  width: 30px;
}

table td.td_content_top {
  padding: 20px 20px 0px 0px;
  width: 650px;
}
table td.td_content_middle {
  padding: 0px 20px 0px 0px;
  width: 650px;
}
table td.td_content_link_title {
  padding: 0px 0px 0px 0px;
  width: 185px;
}
table td.td_content_link_url {
  padding: 0px 20px 0px 5px;
}
table td.td_content_bottom {
  padding: 0px 20px 20px 0px;
  text-align: left;
}
table td.td_check_top {
  text-align: left;
}
table td.td_head_time {
  text-align: right;
  padding: 0px 5px 20px 15px;
  width: 50px;
}
table td .text_title, .text_body, .text_link_title, .text_link_url {
  width: 100%;
}

table td.td_head_top_disaster {
  text-align: left;
  padding: 20px 0px 20px 20px;
  width: 190px;
}

.area_name {
  text-align: left;
  padding-left: 10px;
}
.area_name_disabled {
  text-align: left;
  padding-left: 10px;
  background-color: lightgray;
}
.check_area, .check_sound {
  vertical-align: middle;
}
.btn_header {
  padding: 0;
}
/* 以下、プレビューCSS */
.disp {
  width:320px;
  height:468px;
}
.ios_preview {
  position: absolute;
}
.android_preview {
  position: absolute;
  margin-left: 20px;
}
#ios {
  position: relative;
  margin: 20px 20px 20px 0;
  display: inline-block;
  border: 1px solid black;
  background: linear-gradient(#3E4599, #c2d4ff);
}
#ios_push {
  position: absolute;
  width: 300px;
  min-height: 100px;
  background: #E7EBEE;
  margin-top: 20px;
  margin-left: 9px;
  border-radius: 8px;
  height:auto;
	overflow:hidden;
  max-height: 90%;
  /* overflow: auto; */
}
#ios_icon {
  float: left;
  width: 20px;
  height: auto;
  margin: 6px;
}
.ios_notification {
  float: left;
  text-align: left;
  padding-top: 7px;
  width: 74%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: bold;
}
#ios_bar {
  background-color: #EEF1F3;
  width: 100%;
  height: 30px;
}
.ios_title {
  float: left;
  text-align: left;
  min-height: 18px;
  width: 98%;
  padding-left: 4px;
  font-size: 105%;
  font-weight: bold;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ios_batsu {
  font-size: 200%;
  float: right;
  margin-right: 8px;
}
.ios_message {
  float: left;
  text-align: left;
  width: 95%;
  font-size: 105%;
  color: #6d6d6d;
  margin-left: 4px;
  margin-bottom: 10px;
  word-break: break-all;
}
#android {
  position: relative;
  margin: 20px 0 20px 20px;
  display: inline-block;
  border: 1px solid black;
  background: linear-gradient(#3E4599, #c2d4ff);
}
#android_push {
  position: absolute;
  width: 300px;
  min-height: 100px;
  background: #CED7DD;
  margin-top: 20px;
  margin-left: 9px;
  border-radius: 2px;
  height:auto;
	overflow:hidden;
  max-height: 90%;
  /* overflow: auto; */
}
#android_icon {
  position:absolute;
}
.android_icon {
  width: 38px;
  height: auto;
  margin-top: 12px;
  margin-left: 8px;
  border-radius: 50%;
}
#android_title {
  /* position:absolute; */
  margin-left: 46px;
  width: 252px;
}
.android_title {
  float: left;
  text-align: left;
  padding-top: 12px;
  padding-left: 6px;
  font-size: 110%;
  font-weight: bold;
  width: 88%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.android_time {
  font-size: 100%;
  float: right;
  margin-top: 12px;
  margin-right: 4px;
  color: #848484;
}
.android_message {
  /* margin-top: 30px; */
  margin-left: 45px;
  margin-bottom: 10px;
  width: 78%;
  float: left;
  text-align: left;
  padding-left: 4px;
  font-size: 112%;
  /* font-size: 85%; */
  color: #6d6d6d;
  word-break: break-all;
}

.disasterPull {
  width: 150px;
  margin-left: auto;
  margin-right: 100%;
}

.datepicker_disaster input {
  width: 100%;
}

.td_content_date {
  width: 150px;
}

.td_content_time {
  position: relative;
}

.disaster_time {
  position: absolute;
  left: 10px;
  top: 0.3em;
  margin-left: auto;
  margin-right: 100%;
}

.display_time {
  position: absolute;
  left: 10px;
  top: 0.3em;
}

.time_message {
  margin-top: 27px;
  margin-left: 10px;
}

.modal-header, .modal-body {
  padding: 5px 25px;
}
.modal_header {
  border-bottom: 1px solid #ddd;
  height: 60%;
}
.modal_title {
  color: black;
  text-align: center;
  line-height:100px;
}
.modal-body {
  margin: 0 auto;
  height: 40%;
}
.modal_string_div {
  height: 50%;
  text-align: left;
}
.modal_string {
  font-size: small;
  margin-left: 23px;
}
.modal_li {
  font-size: small;
}
.modal_btn_div {
  margin: 0 auto;
  display: flex;
  justify-content: center;
  height: 100%;
}
.modal_btn {
  margin: auto 10px 20px 0;
}
.tabs {
  display: flex;
}
.tab {
  font-size: x-small;
  padding: 5px 5px;
  border: 1px solid #ccc;
  cursor: pointer;
  transition: .3s;
}
.tab:hover {
  background: #eeeeee;
}
.active {
  background: #aaa9a9;
}
.group_link {
  float: right;
  margin: 0 20px 0 0;
  cursor: pointer;
  color: blue;
}
.modal-header_group, .modal-body_group {
  padding: 5px 25px;
}
.modal_header_group {
  /* border-bottom: 1px solid #ddd; */
  height: 20%;
}
.modal_title_group {
  color: black;
  text-align: center;
  line-height:100px;
}
.modal-body_group {
  height: 60%;
  overflow: scroll;
}
.modal-btn_group {
  height: 15%;
}
.modal_btn_div_group {
  text-align: center;
  /* bottom: 10px;
  left: 45%; */
  margin: 0 0 15px 0;
}
.tab_message {
  text-align: left;
  font-size: small;
}

</style>